import type { AnalyticsCacheStatus } from '../models/analytics-cache-status.model';

/** Whether a WebSocket payload should clear the runtime refresh loader. */
export function shouldEndCardRefreshAfterWebSocket(
	cacheStatus?: AnalyticsCacheStatus
): boolean {
	return cacheStatus !== 'stale';
}

/**
 * Whether to clear the runtime refresh loader after a chart WebSocket event.
 * Rejected payloads still end the refresh unless a fresh `computed` payload is
 * expected after an intermediate `stale` event.
 */
export function shouldEndCardRefreshAfterWebSocketChartEvent(
	cacheStatus: AnalyticsCacheStatus | undefined,
	applied: boolean
): boolean {
	if (!shouldEndCardRefreshAfterWebSocket(cacheStatus)) {
		return false;
	}
	return applied || cacheStatus !== 'stale';
}

export function readWebSocketCacheStatus(
	event: { cacheStatus?: unknown } | null | undefined
): AnalyticsCacheStatus | undefined {
	const raw = event?.cacheStatus;
	if (raw === 'hit' || raw === 'stale' || raw === 'computed') {
		return raw;
	}
	return undefined;
}
